<template>
  <div class="wrapper-auth" v-loading="isFetchingData">
  </div>
</template>

<script>
  import authServices from '@/services/auth'
  export default {
    name: 'confirm',
    data () {
      return {
        isFetchingData: false
      }
    },
    methods: {
      fetchingData () {
        this.isFetchingData = true
        if (this.$router.currentRoute.query && this.$router.currentRoute.query.token) {
          authServices.confirmEmail(this.$router.currentRoute.query.token)
            .then(res => {
              setTimeout(() => {
                this.isFetchingData = false
                localStorage.setItem('access_token', res.token)
                authServices.check()
              }, 3000)
            })
            .catch(e => {
              console.log(e)
              this.$router.push({name: 'login'})
              this.isFetchingData = false
            })
        }
      }
    },
    mounted () {
      this.fetchingData()
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/auth/confirm-email.vue